import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { ICaseClosingSummary } from '../models/caseClosingSummary';

@Injectable({
  providedIn: 'root'
})
export class CaseClosingSummaryService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getCaseClosingSummaryByCaseId(caseId: string): Observable<ICaseClosingSummary> {
        const url = environment.apiBaseUrl + endpoints.getCaseClosingSummaryByCaseId.replace(':caseId', caseId);
        return this.http.get<ICaseClosingSummary>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateCaseClosingSummary(data: ICaseClosingSummary): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.updateCaseClosingSummary;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }
}